var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CategoryInfoImage',{staticClass:"category-info-image",attrs:{"category":_vm.category}}),_vm._v(" "),_c('div',{staticClass:"publication-category-description pt-4 pb-4"},[_vm._v("\n    "+_vm._s(_vm.categoryDescription)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }